import React from 'react';
import { string, shape, arrayOf, func, number, bool } from 'prop-types';
import Datepicker from './Datepicker';
// import { toTimestamp } from '../../utils/date-converter';

export default class DateRangeFilter extends React.Component {
    constructor(props) {
        super(props);

        this.handleDateChange = this.handleDateChange.bind(this);
    }

    handleDateChange(valueIndex, dateObject) {
        const newValue = [...this.props.selectedItems];
        newValue[valueIndex] = dateObject.getTime().toString();
        this.props.toggleFilters.call(this, this, this.props.filter, newValue, false);
    }

    render() {
        return (
            <div className={`date-range-wrapper date-filter form-element ${this.props.classModifier}`}>
                <Datepicker
                    label="Date"
                    datepickerID="filter-date-range-from"
                    placeholderText={this.props.placeholderText ? this.props.placeholderText : 'Date From'}
                    maxDate={this.props.maxDate}
                    defaultDate={this.props.selectedItems ? parseInt(this.props.selectedItems[0], 10) : 0}
                    handleDate={date => { this.handleDateChange(0, date); }}
                    limitedDate={this.props.limitedDate}
                />
                <Datepicker
                    label="to"
                    datepickerID="filter-date-range-to"
                    placeholderText={this.props.placeholderText ? this.props.placeholderText : 'Date To'}
                    maxDate={this.props.maxDate}
                    defaultDate={this.props.selectedItems ? parseInt(this.props.selectedItems[1], 10) : 0}
                    handleDate={date => { this.handleDateChange(1, date); }}
                    limitedDate={this.props.limitedDate}
                />
            </div>
        );
    }
}

DateRangeFilter.propTypes = {
    /* eslint-disable react/no-typos */
    // The disable is needed until https://github.com/yannickcr/eslint-plugin-react/issues/1389 is resolved
    filter: shape({
        code: string.isRequired,
        label: string.isRequired,
        values: arrayOf(string)
    }).isRequired,
    selectedItems: arrayOf(string),
    classModifier: string,
    maxDate: number.isRequired,
    placeholderText: string,
    toggleFilters: func.isRequired,
    limitedDate: bool.isRequired
    /* eslint-enable react/no-typos */
};

DateRangeFilter.defaultProps = {
    classModifier: '',
    selectedItems: ['0', '0'],
    placeholderText: ''
};
